import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import classnames from 'classnames';
import { formatMonths } from '@/helpers/date';
import { Chart } from './chart';
import s from './index.module.scss';

export const GrowthChart = ({ data }) => {
  const { values } = useFormikContext();
  const { t } = useTranslation('calculator');
  const periodLabel = formatMonths(values.term, t).full_label;

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <h2 className={classnames(s.title, 'f-hero-h5')}>
          {t('graph.projected_growth')}
        </h2>
        <div className={classnames(s.period, 'f-small-regular')}>
          {periodLabel}
        </div>
      </div>
      <Chart data={data.projected_growth} />
    </div>
  );
};
